import { CustomElement, resolve } from 'aurelia';
import { UsersReportAdminService } from '../../services';
import template from './users-report-admin-panel.html';
import './users-report-admin-panel.css';

// Admin-only modal that lists every registered user with their saved-search count and current
// notification settings. Opened from the admin menu; all state and the load call live in
// UsersReportAdminService. Read-only: it is an audit view, not an editor.
export class UsersReportAdminPanelElement {
  readonly usersReport: UsersReportAdminService = resolve(UsersReportAdminService);
}

export const UsersReportAdminPanel = CustomElement.define({
  name: 'users-report-admin-panel',
  template
}, UsersReportAdminPanelElement);
